import {
  IFetchBrokerIdRequest,
  IMasterBrokerRequest,
} from "../types/f-d-s-d-p-deposit-summary-types.types";
import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";

interface IBrokerResponse {
  brokerId: string;
  brokerName?: string;
  agentType?: string;
}

export const fetchBrokerID = async (
  reqData: IFetchBrokerIdRequest
): Promise<IResponse<IBrokerResponse>> => {
  const response: IResponse<IBrokerResponse> = await encryptedRequest({
    method: "POST",
    url: API_PATHS.fetchBrokerId,
    data: reqData,
  });
  return response;
};

export const fetchMasterBrokerDetails = async (
  reqData: IMasterBrokerRequest
): Promise<IResponse<IBrokerResponse>> => {
  const response: IResponse<IBrokerResponse> = await encryptedRequest({
    method: "POST",
    url: API_PATHS.masterBroker,
    data: reqData,
  });
  return response;
};
